import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import {
  TrainTab,
  useTabsContext,
} from "features/CenterContent/shared/Tabs/useTabsContext";
import { TrainListElement } from "features/VehicleSidebar/VehicleList/TrainList/TrainListElement";
import { DateHeader } from "features/VehicleSidebar/VehicleList/TrainList/styles";
import { TrainData } from "features/VehicleSidebar/VehicleList/TrainList/types";
import { formatDateString } from "shared/utils/dateTimeUtils";

type Props = {
  trainDatas: TrainData[];
  internalMessages: InternalMessageResponse[] | undefined;
};

// Section: trainDatas of the same date
export const TrainListSection = ({ trainDatas, internalMessages }: Props) => {
  const { activeIdTabs } = useTabsContext();

  const trainElementSelected = (train: TrainData) =>
    activeIdTabs.some((it) => {
      const tab = it as TrainTab;
      return (
        tab.countryCode === train.countryCode &&
        tab.trainNumber === train.trainNumber &&
        tab.trainDate === train.trainDate
      );
    });

  return (
    <>
      <DateHeader>
        {formatDateString(trainDatas[0].trainDate, "dd.MM.yy")}
      </DateHeader>

      {trainDatas.map((train: TrainData) => (
        <TrainListElement
          key={`${train.trainNumber}_${train.trainDate}`}
          train={train}
          trainElementSelected={trainElementSelected(train)}
          internalMessages={internalMessages}
        />
      ))}
    </>
  );
};
